// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"9379c531","303":"f35622d3","610":"1fac8d29","848":"c84303b8"}[chunkId] + ".chunk.css";
};